export const tabColor = ["#FF9E99", "#79E78A", "#7ABBFF", "#FFD390", "#CE90FF"];
export const tabTextColor = [
  "#860a03",
  "#025e10",
  "#003874",
  "#66543A",
  "#523A66",
];
export const textColor = "#666";
export const borderColor = "#ddd";
export const reviewColor = "#FFB347";
export const recommendColor = "#47A0FF";
export const dangerTextColor = "#FF7C75";

export const hexToRgb = (hex: string) => {
  // http://stackoverflow.com/a/5624139
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const rgba = (hex: string, alpha: number) => {
  const color: { r: number; g: number; b: number } = hexToRgb(hex);
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
};
